import { DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../../../shared/components/ModalBasic";
import { AlertIcon } from "../../../../../shared/icons/AlertIcon";
import { TModalsIds } from "../../../../../app/state/modalSlice/types";
import { useModalSelectors } from "../../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";

interface Props extends Omit<DialogProps, "open"> {
  handleOk: () => void;
  handleCancel: () => void;
  closeModal: (id: TModalsIds) => void;
}

export const MeetingModalInfo = ({
  handleOk,
  handleCancel,
  closeModal,
  ...rest
}: Props) => {
  const modalInfo = useModalSelectors("meeting_info_modal");
  const { t } = useTranslation();
  return (
    <ModalBasic
      open={modalInfo.isOpen}
      onOk={() => {
        handleOk();
        closeModal("meeting_info_modal");
      }}
      hasHeader={false}
      onCancel={() => {
        handleCancel();
        closeModal("meeting_info_modal");
      }}
      onClose={() => closeModal("meeting_info_modal")}
      buttonOkText={t("common.yes")}
      onCancelText={t("common.no")}
      hasFooter
      {...rest}
    >
      <div className={styles["info-container"]}>
        <AlertIcon className={styles["warning-icon"]} />
        <p className={styles.info}>{t("meetings.modal_info")}</p>
      </div>
    </ModalBasic>
  );
};
